import React, { Fragment } from 'react';

const SubNavCompact = ({ subNavigation }) => {
    const topCategory = subNavigation && subNavigation.find(item => item.isSelected);
    const topName = topCategory?.name;
    const topUrl = topCategory?.url;
    const childLinks = topCategory?.links || [];

    return (
        <nav className="subnav" role="navigation">
            <div className="subnav__header">
                {topUrl ? (
                    <a className="subnav__header--link" href={topUrl}>{topName}</a>
                ) : (
                    <span>{topName}</span>
                )}
            </div>
            {childLinks && childLinks.length > 0 && (
                <ul className="subnav__list level-1">
                    {childLinks.map((link, index) => displaySubNavItem(link, index, 2))}
                </ul>
            )}
        </nav>
    );
};

const displaySubNavItem = (item, index, level) => {
    const { name, url, isSelected, links } = item;
    const hasChildren = links && links.length > 0;

    return (
        <li
            className={`subnav__item ${hasChildren ? 'has-children' : ''} ${isSelected ? 'active' : ''}`}
            key={`subnav-${level}-${index}`}
        >
            <a
                className="subnav__link"
                href={url ?? '#'}
                rel={url && url.length > 0 ? '' : 'nofollow'}
            >
                {name}
            </a>
            {hasChildren && (
                <span className="subnav__submenu-link"></span>
            )}
            {hasChildren && (
                <ul className={`subnav__list level-${level}`}>
                    {links.map((child, childIndex) => displaySubNavItem(child, childIndex, level + 1))}
                </ul>
            )}
        </li>
    );
};

export default SubNavCompact;
